import LinkSpeechToText from './LinkSpeechToText';

export default LinkSpeechToText;
